module.exports = __webpack_public_path__ + "img/vip.1b9e97ad.png";